/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Start_DateInputs */

const en_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const de_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

const fr_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de debut`)
};

const es_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio`)
};

const it_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di inizio`)
};

const nl_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

const pl_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data rozpoczecia`)
};

const fi_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloituspäivä`)
};

const da_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdato`)
};

const sv_resume_editor_start_date = /** @type {(inputs: Resume_Editor_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {Resume_Editor_Start_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_start_date = /** @type {((inputs?: Resume_Editor_Start_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Start_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_start_date(inputs)
	if (locale === "fr") return fr_resume_editor_start_date(inputs)
	if (locale === "es") return es_resume_editor_start_date(inputs)
	if (locale === "it") return it_resume_editor_start_date(inputs)
	if (locale === "nl") return nl_resume_editor_start_date(inputs)
	if (locale === "pl") return pl_resume_editor_start_date(inputs)
	if (locale === "fi") return fi_resume_editor_start_date(inputs)
	if (locale === "da") return da_resume_editor_start_date(inputs)
	if (locale === "sv") return sv_resume_editor_start_date(inputs)
	return en_resume_editor_start_date(inputs)
});